import { Pipe, PipeTransform } from '@angular/core';
import sanitize from 'sanitize-html';

@Pipe({
    name: 'stripTags',
    standalone: false,
})
export class StripTagsPipe implements PipeTransform {
    transform(value: string): string {
        return sanitize(value, {
            allowedTags: [],
            allowedAttributes: {},
        });
    }

}
